<template>
    <GenericPage
        :headerProps="{
            title: $t('cp__widgets__title'),
            subtitle: $t('customer_portal_widgets_intro'),
            disableBackButton: true,
        }"
        :loading="isLoading"
    >
        <div class="widgets__page">
            <div class="widgets__items">
                <WidgetPreview
                    v-for="widget in allWidgets"
                    :key="widget.id"
                    :widget="widget"
                    @openFullSize="openFullSizePreview"
                />
            </div>
        </div>

        <FullSizeWidgetPopup
            v-if="openFullSizePopup"
            :preview="preview"
            :previewIsVideo="previewIsVideo"
            @close="cancel"
        />
    </GenericPage>
</template>

<script>
import { mapGetters } from "vuex";
import GenericPage from "@/components/Global/Molecules/GenericPage.vue";
import WidgetPreview from "@/components/Widgets/Molecules/WidgetPreview.vue";
import FullSizeWidgetPopup from "@/components/Global/Atoms/FullSizeWidgetPopup.vue";
import getWidgets from "@/graphql/widgets/getWidgets.gql";

export default {
    name: "Widgets",
    components: {
        WidgetPreview,
        GenericPage,
        FullSizeWidgetPopup,
    },
    data() {
        return {
            isLoading: false,
            openFullSizePopup: false,
            preview: null,
            previewIsVideo: false,
            allWidgets: [],
        };
    },
    computed: {
        ...mapGetters({
            activeAccount: "AccountStore/activeAccount",
        }),
    },
    methods: {
        openFullSizePreview(preview) {
            this.preview = preview.preview;
            this.previewIsVideo = preview.isVideo;
            this.openFullSizePopup = true;
        },
        cancel() {
            this.openFullSizePopup = false;
        },
    },
    async created() {
        this.isLoading = true;
        const { data } = await this.$apollo.query({
            query: getWidgets,
            variables: {
                divisionUuid: this.activeAccount.externalUuid,
            },
        });

        this.allWidgets = data.widgets;
        this.isLoading = false;
    },
};
</script>

<style lang="scss" scoped>
@import "@/style_variables/style_variables.scss";
@import "~include-media";

.widgets__page {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: $grey_bg;
    max-width: 950px;

    @include media(">=tablet") {
        width: 100%;
    }
}

.widgets__items {
    display: grid;
    width: 100%;
    background-color: $grey_bg;
    padding: 40px 0;
    gap: 40px 40px;
    grid-template-columns: repeat(2, 356px);
    grid-auto-rows: auto;

    @include media($isPhone...) {
        grid-template-columns: 356px;
    }
}
</style>
